"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ortbObject = exports.OpenRtb = void 0;
// import Bid from './Bid';
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var utils_1 = require("../utils/utils");
var ConsentHandler_1 = require("./consent/ConsentHandler");
var __1 = require("..");
var IdentityAdapeterHandler_1 = require("./identityAdapters/IdentityAdapeterHandler");
var User_1 = require("./User");
/**
 * @class OpenRtb
 * @description Class to create an OpenRTB Object
 * OpenRTB 2.5 Spec: https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf
 */
var OpenRtb = /** @class */ (function () {
    function OpenRtb() {
    }
    /**
     * @param {Object} json - JSON Object
     * @returns {Object} - OpenRTB Object
     * @description Returns the OpenRTB Object
     */
    OpenRtb.prototype.initObj = function (json) {
        if (json === void 0) { json = {}; }
        // Set test mode
        var test = __1.globalSettings.test.enabled && __1.globalSettings.test.ids ? 1 : 0;
        // Set default values
        var defaultJson = {
            id: (0, utils_1.generateUUID)(),
            at: 1,
            imp: [],
            site: this.createSiteObj(),
            device: this.createDeviceObj(),
            user: this.createUserObj(),
            regs: this.createRegsObj(),
            source: this.createSourceObj(),
            cur: ["USD"],
            test: test,
            tmax: 450,
            ext: {}, // Ext Object
        };
        return (0, utils_1.deepMerge)(defaultJson, json);
    };
    OpenRtb.prototype.createSiteObj = function () {
        var _a;
        var url = (0, utils_1.getURL)();
        var referrer = ((_a = (0, utils_1.getReferrer)()) === null || _a === void 0 ? void 0 : _a.href) || "";
        return {
            // id: "", // Site ID
            name: __1.globalSettings.site_name || "",
            domain: url.hostname || "",
            page: url.href || "",
            ref: referrer || "",
            search: url.search || "",
            publisher: this.createPublisherObj(url), // Publisher Object
            // mobile: "", // Mobile-optimized site
            // cat: [], // Array of IAB content categories
            // sectioncat: [], // Array of IAB content categories
            // pagecat: [], // Array of IAB content categories
            // content: {}, // Content Object
            // keywords: "", // Comma separated list of keywords
            // ext: {}, // Ext Object
        };
    };
    OpenRtb.prototype.createPublisherObj = function (url) {
        return {
            // id: "", // Publisher ID
            name: __1.globalSettings.site_name || "",
            // cat: [], // Array of IAB content categories
            domain: url.hostname || "", // Publisher Domain
            // ext: {}, // Ext Object
        };
    };
    /**
     * @returns {Object} - Device Object
     * @description Creates a Device Object
     */
    OpenRtb.prototype.createDeviceObj = function () {
        // Parse User Agent
        var ua = new ua_parser_js_1.default((0, utils_1.getUserAgent)());
        // Set device type
        var devicetype = 0;
        switch (ua.getDevice().type) {
            case 'mobile':
                devicetype = 4;
                break;
            case 'tablet':
                devicetype = 5;
                break;
            case 'smarttv':
                devicetype = 3;
                break;
            case 'console':
                devicetype = 2;
                break;
            default:
                devicetype = 2;
                break;
        }
        return {
            ua: (0, utils_1.getUserAgent)() || "",
            geo: this.createGeoObj(),
            dnt: (0, utils_1.getDNT)() || 0,
            devicetype: devicetype,
            make: ua.getDevice().vendor || "",
            model: ua.getDevice().model || "",
            os: ua.getOS().name || "",
            osv: ua.getOS().version || "",
            // hwv: "",
            // h: 0,
            // w: 0,
            js: 1,
            language: (0, utils_1.getBrowserLanguage)(), // Browser language using ISO-639-1-alpha-2
            // connectiontype: 0, // 0 = Unknown, 1 = Ethernet, 2 = WIFI, 3 = Cellular Network – Unknown Generation, 4 = Cellular Network – 2G, 5 = Cellular Network – 3G, 6 = Cellular Network – 4G
            // ext: {}, // Ext Object
        };
    };
    /**
     * @returns {Object} - Geo Object
     * @description Creates a Geo Object
     */
    OpenRtb.prototype.createGeoObj = function () {
        return {};
    };
    /**
     * @returns {Object} - User Object
     * @description Creates a User Object
     */
    OpenRtb.prototype.createUserObj = function () {
        var eids = IdentityAdapeterHandler_1.globalIdentityAdapeterHandler.getUserIdsAsEids() || [];
        return {
            id: User_1.globalUser.getUUID(),
            buyeruid: "",
            geo: this.createGeoObj(),
            // data: [], // Data Object
            ext: {
                consent: ConsentHandler_1.gdprConsentHandler.getGdprString(),
                eids: eids, // Array of User ID Objects
            }
        };
    };
    /**
     * @returns {Object} - Regs Object
     * @description Creates a Regs Object
     */
    OpenRtb.prototype.createRegsObj = function () {
        var gpp = ConsentHandler_1.gppConsentHandler.getGppString();
        var gpp_sid = ConsentHandler_1.gppConsentHandler.getApplicableSections();
        var regs = {
            coppa: Number(ConsentHandler_1.coppaDataHandler.getCoppa()),
            ext: {
                gdpr: Number(ConsentHandler_1.gdprConsentHandler.getGdprApplies()),
                us_privacy: ConsentHandler_1.uspConsentHandler.getUsPrivacy(),
                gpp: gpp,
                gpp_sid: gpp_sid,
            }
        };
        if (!gpp || !gpp_sid.length || gpp_sid.includes(-1)) {
            delete regs.ext.gpp;
            delete regs.ext.gpp_sid;
        }
        return regs;
    };
    /**
     * @returns {Object} - Source Object
     * @description Creates a Source Object
     */
    OpenRtb.prototype.createSourceObj = function () {
        return {
            ext: {
                schain: __1.globalSettings.schain || { complete: 1, nodes: [], ver: "1.0" },
            },
        };
    };
    return OpenRtb;
}());
exports.OpenRtb = OpenRtb;
exports.ortbObject = new OpenRtb();
